import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useLocalEstoqueCombo } from "@/features/estoque/hooks/useLocalEstoque";
import { cn } from "@/lib/utils";

const NENHUM = "__none__";

interface LocalEstoqueSelectProps {
  value?: number | null;
  /** `undefined` = "Todos"/nenhum escolhido. */
  onChange: (id: number | undefined) => void;
  /** Rótulo da opção vazia (ex.: "Todos os locais"). Sem ele não há opção vazia (campo obrigatório). */
  rotuloTodos?: string;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
}

/**
 * Select de local de estoque pelo NOME (lista curta, vem de /api/locais-estoque).
 * Padroniza a sentinela da opção vazia (`__none__`) — Radix não aceita `value=""`.
 */
export function LocalEstoqueSelect({
  value, onChange, rotuloTodos, placeholder = "Selecione o local...", disabled, className,
}: LocalEstoqueSelectProps) {
  const { data: locais = [], isLoading } = useLocalEstoqueCombo();
  const atual = value ? String(value) : rotuloTodos ? NENHUM : "";

  return (
    <Select
      value={atual}
      disabled={disabled}
      onValueChange={(v) => onChange(v === NENHUM ? undefined : Number(v))}
    >
      <SelectTrigger className={cn("w-full", className)}>
        <SelectValue placeholder={isLoading ? "Carregando..." : placeholder} />
      </SelectTrigger>
      <SelectContent>
        {rotuloTodos && <SelectItem value={NENHUM}>{rotuloTodos}</SelectItem>}
        {locais.map((l) => (
          <SelectItem key={l.id} value={String(l.id)}>{l.descricao}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
